export enum OutputType {
    Integration = "Integration",
    Email = "Email",
    CaseEngine = "Case engine",
}
